import { Grid, GridSize } from '@material-ui/core';
import React from 'react';

import { publicaColors } from '~/src/dash/utils/colors';
import { IIASDashboardMetricsCard } from '~/src/dash/views/ias-publisher/IASDashboard/common/types';
import { IASDashboardCard } from '~/src/dash/views/ias-publisher/IASDashboard/IASDashboardCards/IASDashboardCard';

const getCardGridSize = (numCards: number) => {
  switch (numCards) {
    case 2:
      return 6 as GridSize;
    case 3:
      return 4 as GridSize;
    case 4:
      return 3 as GridSize;
    default:
      return true;
  }
};

interface IIASDashboardCardsProps {
  cards: IIASDashboardMetricsCard[];
  isComparedToEnabled: boolean;
  handleClickCard: (key: string) => void;
  loadStatus: number;
  activeMetrics: Record<string, boolean>;
}

export const IASDashboardCards = ({
  cards,
  isComparedToEnabled,
  handleClickCard,
  loadStatus,
  activeMetrics,
}: IIASDashboardCardsProps) => {
  const numCards = cards.length;
  return (
    <Grid container spacing={2}>
      {cards.map((card) => {
        return (
          <Grid item xs={getCardGridSize(numCards)}>
            <IASDashboardCard
              color={card.color || publicaColors.gray}
              isComparedToEnabled={isComparedToEnabled}
              isInverseMetric={card.isInverseMetric}
              isPercentChangeNegative={card.isPercentChangeNegative}
              label={card.label}
              percentChange={card.percentChange}
              value={card.value}
              isActive={activeMetrics[card.dataKey]}
              handleClickCard={handleClickCard}
              loadStatus={loadStatus}
              dataKey={card.dataKey}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
